import React from 'react';
import Transcription from "./Transcription";
import '../../css/tabulky.css';

class StartListTable extends React.Component {

    render() {
        let hiddenRow =
            <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                {/*<td>&nbsp;</td>*/}
                {/*<td>&nbsp;</td>*/}
                {/*<td>&nbsp;</td>*/}
                {/*<td>&nbsp;</td>*/}
                {/*<td>&nbsp;</td>*/}
            </tr>;

        return (
            // <div className="body2">
                <div className="card">
                    <div className="cardContent">
                        <table id="treti">
                            <tbody>

                            <tr>
                                <td style={{backgroundColor: "#3e3d53", color: "#fff", fontWeight: "700"}}>Status</td>
                                <td style={{backgroundColor: "#3e3d53", color: "#fff", fontWeight: "700"}}>Stč</td>
                                <td style={{
                                    backgroundColor: "#3e3d53",
                                    color: "#fff",
                                    fontWeight: "700",
                                    textAlign: "left"
                                }}>Jméno
                                </td>
                                <td style={{
                                    backgroundColor: "#3e3d53",
                                    color: "#fff",
                                    fontWeight: "700",
                                    textAlign: "left"
                                }}>Oddíl/klub
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="4" style={{backgroundColor: "#3e3d53", color: "#fff", fontWeight: "700"}}>
                                    Startovní listina
                                </td>
                            </tr>
                            {this.props.athletes.map((athlet, key) => (
                                <tr key={athlet.id}>
                                    <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{Transcription.changeFlg(athlet.flg)}</td>
                                    <td style={{backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa'}}>{athlet.bib}</td>
                                    <td style={{
                                        backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa',
                                        textAlign: "left"
                                    }}>{athlet.jmeno}</td>
                                    <td style={{
                                        backgroundColor: key % 2 === 1 ? '#f0f0f7' : '#fafafa',
                                        textAlign: "left"
                                    }}>{athlet.tj === "    " ? athlet.klub : athlet.tj}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            // </div>
        )
    }
}

export default StartListTable;